import React from 'react';

import { TableRow } from '@material-ui/core';

export default function FooterRow({ row, children, ...props }) {
    return <TableRow {...props}>{children}</TableRow>;
}
